import { FilterListItem } from '@/components/common/Filter'
import { Mana } from '@/components/common/Mana'
import {
  CARD_FILTER_COLORS_OPERATOR_LABELS,
  CARD_FILTER_LABELS,
  type CardFilterPartialType,
  isCardFilterBooleanType,
  isCardFilterColorsType,
  isCardFilterNumberType,
  isCardFilterSearchType,
  isCardFilterSelectType,
} from '@/defs/cardFilters'
import { NUMBER_OPERATOR_LABELS, SET_OPERATOR_LABELS } from '@/defs/common'

type Props = {
  cardFilter: CardFilterPartialType
  onDelete: () => void
  onEdit: () => void
}

export const GalleryCardFiltersItem = ({ cardFilter, onDelete, onEdit }: Props) => {
  const icon = CARD_FILTER_LABELS[cardFilter.slug].icon
  const label = isCardFilterBooleanType(cardFilter) ? (
    `${CARD_FILTER_LABELS[cardFilter.slug].label}`
  ) : isCardFilterColorsType(cardFilter) ? (
    <>
      {CARD_FILTER_COLORS_OPERATOR_LABELS[cardFilter.operator].label}: <Mana colors={cardFilter.colors} />
    </>
  ) : isCardFilterNumberType(cardFilter) ? (
    `${NUMBER_OPERATOR_LABELS[cardFilter.operator].labelLong} ${cardFilter.number} ${CARD_FILTER_LABELS[cardFilter.slug].label}`
  ) : isCardFilterSearchType(cardFilter) ? (
    `${CARD_FILTER_LABELS[cardFilter.slug].label}: ${cardFilter.search || ''}`
  ) : isCardFilterSelectType(cardFilter) ? (
    `${SET_OPERATOR_LABELS[cardFilter.operator].label} ${CARD_FILTER_LABELS[cardFilter.slug].label}: ${cardFilter.selections.map((s) => s.label).join(', ')}`
  ) : null

  return <FilterListItem icon={icon} label={label} onDelete={onDelete} onEdit={onEdit} />
}
